import styled from 'styled-components';
import Theme from '../theme/Theme';

const InfoMsg = styled.div`
  color: ${Theme.orange};
  font-size: ${Theme.extraNormal};
  padding: 0;
  margin: 0 0 0 0;
  transform: translate(0, 6px);

  a {
    text-transform: lowercase;
    text-decoration: underline;
    display: block;
    color: ${Theme.orange};
    font-size: ${Theme.extraSmall};
  }
`;
export default InfoMsg;
